import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ColumnClassNamesType from '../../../propTypes/columnClassNamesType';
import { default as FA, getIconByName } from '../../../utils/FA';

const LinkCell = ({ contact, value, link, newTab, columnClassNames, fontAwesomeIcon }) => {
  let linkDisplay;
  let href;
  const icon = getIconByName(fontAwesomeIcon);

  if (typeof value === 'function') {
    linkDisplay = value(contact);
  } else if (typeof value === 'string') {
    linkDisplay = contact[value];
  }

  if (typeof link === 'function') {
    href = link(contact);
  } else if (typeof link === 'string') {
    href = contact[link];
  }

  if (!linkDisplay || !href) {
    return <td className='contact-list-react-name'>{linkDisplay}</td>;
  }

  return (
    <td className={classNames('contact-list-react-name', columnClassNames)}>
      {!!fontAwesomeIcon && <FA icon={icon} nbsp />}
      {newTab
        ? <a href={href} target='_blank' rel='noopener noreferrer'>{linkDisplay}</a>
        : <a href={href}>{linkDisplay}</a>}
    </td>
  );
};

LinkCell.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** Open in new tab */
  newTab: PropTypes.bool,
  columnClassNames: ColumnClassNamesType,
  fontAwesomeIcon: PropTypes.string
};
LinkCell.defaultProps = {
  link: (contact) => '',
  value: (contact) => '',
  newTab: false,
  columnClassNames: '',
  fontAwesomeIcon: ''
};

export default LinkCell;
